'use strict';

define(
    'TrackSelectorItemCurrentRaceFactory',[
        'TrackSelectorItemBuilder'
    ],
    function (TrackSelectorItemBuilder) {

        function TrackSelectorItemsCurrentRaceFactory(FavoriteTracksFac) {

            var _mappers = {
                toTrackSelectorItem: function (trackName, trackAbbr, raceNumber, racePostTime, perfAbbr, currentWagerableRace) {
                    return TrackSelectorItemBuilder()
                        .withTrackName(trackName)
                        .withTrackAbbr(trackAbbr)
                        .withRaceNumber(raceNumber)
                        .withPostTime(racePostTime)
                        .withPerfAbbr(perfAbbr)
                        .withCurrentWagerableRace(currentWagerableRace)
                        .build();
                }
            };

            function _mapToTrackSelectorItem(track) {
                return _mappers.toTrackSelectorItem(track.name, track.trackAbbr, track.currentRace, track.currentWagerableRacePostTime, track.perfAbbr, track.currentWagerableRace);
            }

            return {
                createTrackSelectorItemsForFavoriteTracks: function (tracks) {
                    var favoritesTracks = FavoriteTracksFac.getFavoriteTracks();
                    if (!favoritesTracks || favoritesTracks.length === 0) {
                        return [];
                    }
                    return tracks.filter(function (track) {
                        return track.currentRace !== 0 && favoritesTracks.indexOf(track.trackAbbr) >= 0;
                    }).map(_mapToTrackSelectorItem);
                },

                createTrackSelectorItemsForFeaturedTracks: function (tracks) {
                    return tracks.filter(function (track) {
                        return track.currentRace !== 0 && track.featured == true;
                    }).map(_mapToTrackSelectorItem);
                },

                createTrackSelectorItemsForAllTracks: function (tracks) {
                    return tracks.filter(function (track) {
                        return track.currentRace !== 0;
                    }).map(_mapToTrackSelectorItem);
                }
            };

        }

        TrackSelectorItemsCurrentRaceFactory.$inject = [
            'FavoriteTracksFac'
        ];

        return TrackSelectorItemsCurrentRaceFactory;
    }
);

